import React from 'react';
import { Clock3Icon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="bg-[#241622] px-5 py-16" data-id="element-248" data-mp="2sk41l62s7846">
      <div className="mx-auto max-w-2xl border-2 border-[#d770ae] bg-[#38233c] p-8 text-center sm:p-11" data-id="element-249" data-mp="36ahc9g7250x7">
        <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.2em] text-[#f4b4d8]" data-id="element-250" data-mp="31ipiyxwioh3d">
          <Clock3Icon className="h-4 w-4" data-id="element-251" data-mp="3g72ig4utci2m" />
          Offerta a tempo limitato
        </p>
        <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-none text-white sm:text-5xl" data-id="element-252" data-mp="3b9twdt6jntw3">
          Il prezzo di lancio scade tra:
        </h2>
        <div className="my-9" data-id="element-253" data-mp="3p6h6yyrf6ikh">
          <CountdownTimer size="large" dark data-id="element-254" data-mp="3l6ymu57fabip" />
        </div>
        <p className="font-semibold text-white" data-id="element-255" data-mp="3l5drweh74qkb">
          Dopo, il prezzo aumenterà di €5 e non scenderà mai più.
        </p>
        <div className="mx-auto mt-7 max-w-sm" data-id="element-256" data-mp="1qtgywh33vcn5">
          <div className="h-3 overflow-hidden border border-[#d770ae]/50 bg-[#140c16]" data-id="element-257" data-mp="1qus2afsn2idq">
            <div className="h-full w-[72%] bg-[#c02970]" data-id="element-258" data-mp="2suzg210vmp99" />
          </div>
          <div className="mt-3 flex justify-between text-[10px] font-bold uppercase tracking-widest" data-id="element-259" data-mp="2xrzkk7i2vjy9">
            <span className="text-[#f4b4d8]" data-id="element-260" data-mp="32rkg07y1ha68">
              Disponibilità limitata — solo per oggi
            </span>
            <span className="text-slate-300" data-id="element-261" data-mp="37jcauuo8a226">72% riscattato</span>
          </div>
        </div>
      </div>
    </section>;
}